"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCourt = void 0;

var React = __importStar(require("react"));

exports.IconCourt = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "38",
    height: "40",
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0294 21.9048V33.3333H29.2482V21.9048H28.0294Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0763 21.9048V33.3333H32.295V21.9048H31.0763Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.639 32.6982C27.6366 32.6982 26.8109 33.5585 26.8109 34.6029V35.5553H28.0296V34.6029C28.0296 34.2442 28.2947 33.968 28.639 33.968H31.6859C32.0301 33.968 32.2952 34.2442 32.2952 34.6029V35.5553H33.514V34.6029C33.514 33.5585 32.6883 32.6982 31.6859 32.6982H28.639Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8107 19.6825V20.6349C26.8107 21.6793 27.6364 22.5396 28.6388 22.5396H31.6856C32.688 22.5396 33.5137 21.6793 33.5137 20.6349V19.6825H32.295V20.6349C32.295 20.9936 32.0299 21.2698 31.6856 21.2698H28.6388C28.2945 21.2698 28.0294 20.9936 28.0294 20.6349V19.6825H26.8107Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7561 21.9048V33.3333H17.9748V21.9048H16.7561Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8027 21.9048V33.3333H21.0215V21.9048H19.8027Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3655 32.6982C16.3631 32.6982 15.5374 33.5585 15.5374 34.6029V35.5553H16.7561V34.6029C16.7561 34.2442 17.0212 33.968 17.3655 33.968H20.4123C20.7566 33.968 21.0217 34.2442 21.0217 34.6029V35.5553H22.2404V34.6029C22.2404 33.5585 21.4147 32.6982 20.4123 32.6982H17.3655Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5374 19.6825V20.6349C15.5374 21.6793 16.3631 22.5396 17.3655 22.5396H20.4123C21.4147 22.5396 22.2404 21.6793 22.2404 20.6349V19.6825H21.0217V20.6349C21.0217 20.9936 20.7566 21.2698 20.4123 21.2698H17.3655C17.0212 21.2698 16.7561 20.9936 16.7561 20.6349V19.6825H15.5374Z",
    fill: color
  }), React.createElement("path", {
    d: "M0.616988 38.73C0.453981 38.7269 0.297071 38.7935 0.181285 38.9126C0.0639826 39.0316 0 39.1951 0 39.3649C0 39.5348 0.0639826 39.6983 0.181285 39.8173C0.297068 39.9364 0.453977 40.003 0.616988 39.9999H37.1608C37.3237 40.003 37.4806 39.9364 37.5964 39.8173C37.7137 39.6983 37.7777 39.5348 37.7777 39.3649C37.7777 39.1951 37.7137 39.0316 37.5964 38.9126C37.4806 38.7935 37.3237 38.7269 37.1608 38.73H0.618548H0.616988Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8893 0.000203158C18.5526 0.000203158 18.2799 0.284328 18.2799 0.635119V8.88881H19.4986V1.26983H24.9828V3.80948H20.4124V5.07933H25.5919C25.9286 5.07933 26.2013 4.79519 26.2013 4.44441V0.634915C26.2013 0.284124 25.9286 0 25.5919 0L18.8893 0.000203158Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.43601 36.1904C2.27301 36.1888 2.1161 36.2539 1.99879 36.373C1.88301 36.492 1.8175 36.6555 1.8175 36.8253C1.8175 36.9952 1.88301 37.1587 1.99879 37.2777C2.11609 37.3968 2.273 37.4634 2.43601 37.4603H35.3419C35.5048 37.4634 35.6619 37.3968 35.779 37.2777C35.8948 37.1587 35.9603 36.9952 35.9603 36.8253C35.9603 36.6555 35.8948 36.492 35.779 36.373C35.6619 36.2539 35.5048 36.1888 35.3419 36.1904H2.43601Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48254 21.9048V33.3333H6.70128V21.9048H5.48254Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52966 21.9048V33.3333H9.7484V21.9048H8.52966Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09214 32.6982C5.08974 32.6982 4.26404 33.5585 4.26404 34.6029V35.5553H5.48277V34.6029C5.48277 34.2442 5.74785 33.968 6.09214 33.968H9.13899C9.48327 33.968 9.74834 34.2442 9.74834 34.6029V35.5553H10.9671V34.6029C10.9671 33.5585 10.1414 32.6982 9.13899 32.6982H6.09214Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26428 19.6825V20.6349C4.26428 21.6793 5.08998 22.5396 6.09239 22.5396H9.13923C10.1416 22.5396 10.9673 21.6793 10.9673 20.6349V19.6825H9.74858V20.6349C9.74858 20.9936 9.48352 21.2698 9.13923 21.2698H6.09239C5.74809 21.2698 5.48302 20.9936 5.48302 20.6349V19.6825H4.26428Z",
    fill: color
  }), React.createElement("path", {
    d: "M18.8477 7.62218C18.773 7.62694 18.6999 7.64599 18.6314 7.67932L1.56907 15.933C1.35427 16.0362 1.21716 16.2616 1.21716 16.5076V18.4124C1.21716 18.7632 1.48986 19.0473 1.82653 19.0473H35.9511C36.2878 19.0473 36.5604 18.7632 36.5604 18.4124V16.5076C36.5604 16.2616 36.4233 16.0362 36.2087 15.933L19.1463 7.67932C19.0534 7.63488 18.9513 7.61424 18.8477 7.62218ZM18.8888 8.95711L35.342 16.9158V17.7793H2.43609V16.9158L18.8888 8.95711Z",
    fill: color
  }), React.createElement("path", {
    d: "M18.889 11.4288C17.5499 11.4288 16.4515 12.5733 16.4515 13.9685C16.4515 15.3637 17.5499 16.5082 18.889 16.5082C20.2281 16.5082 21.3265 15.3637 21.3265 13.9685C21.3265 12.5733 20.2281 11.4288 18.889 11.4288ZM18.889 12.6987C19.57 12.6987 20.1078 13.2606 20.1078 13.9685C20.1078 14.678 19.57 15.2383 18.889 15.2383C18.208 15.2383 17.6703 14.678 17.6703 13.9685C17.6703 13.2606 18.208 12.6987 18.889 12.6987Z",
    fill: color
  }));
});